var map = {
	"./Angular.png": 126,
	"./Certificates/GCloud.pdf": 30,
	"./Certificates/MLSA.png": 127,
	"./Certificates/SIH-2019.jpg": 32,
	"./Coastr icon set-03.png": 26,
	"./G CLoud.png": 128,
	"./Gcloud.png": 29,
	"./Google.png": 129,
	"./LPU.png": 24,
	"./Luxstek.jpeg": 25,
	"./SIH.jpg": 31,
	"./SIH.png": 130,
	"./Truelancer.jpg": 131,
	"./codeInLogo.webp": 132,
	"./contactMail.webp": 133,
	"./contactMailDark.svg": 134,
	"./developerActivity.svg": 61,
	"./dsc.png": 28,
	"./facebookLogo.png": 135,
	"./girlscript.png": 136,
	"./gold.png": 27,
	"./googleAssistant.svg": 137,
	"./googleAssistantLogo.webp": 138,
	"./google_developers.png": 139,
	"./gssoc.png": 140,
	"./hackerearth.png": 141,
	"./jsFramework.svg": 142,
	"./k21.png": 143,
	"./manOnTable.svg": 60,
	"./microsoft.png": 144,
	"./mlsa.png": 145,
	"./nextuLogo.webp": 146,
	"./programmer.svg": 147,
	"./pwa.webp": 148,
	"./pwaLogo.webp": 149,
	"./quoraLogo.png": 150,
	"./skill.svg": 62,
	"./social/Adobe.jpg": 151,
	"./social/Board.jpeg": 53,
	"./social/Board2021.jpeg": 47,
	"./social/CR Mentor.png": 46,
	"./social/CoviHack.jpeg": 49,
	"./social/DSCTeam.jpeg": 52,
	"./social/Gold_MLSA.jpeg": 44,
	"./social/HPC.jpeg": 50,
	"./social/MLCC.png": 152,
	"./social/Mentor2021.jpeg": 48,
	"./social/Mentors.jpeg": 51,
	"./social/OpenForce.png": 43,
	"./social/SCSE_Gold.jpeg": 45,
	"./social/bm-alexa.jpg": 153,
	"./social/gcloud.jpg": 154,
	"./social/google.jpg": 155,
	"./social/iitr.jpg": 156,
	"./social/lead.jpg": 54,
	"./social/ms_edu.jpg": 157,
	"./social/ng.jpg": 55,
	"./social/photo_2020-12-12_21-48-59.jpg": 158,
	"./social/sih-gf.jpg": 58,
	"./social/sih-team.jpg": 159,
	"./social/sih.jpeg": 57,
	"./social/sih.jpg": 160,
	"./social/sih_.jpg": 161,
	"./social/sih_team-.jpg": 162,
	"./social/sih_team.jpg": 56,
	"./talks/AMAMLSA.png": 37,
	"./talks/Fireside.png": 33,
	"./talks/ITW.png": 36,
	"./talks/LinkedIn.jpg": 41,
	"./talks/PowerBI.jpeg": 34,
	"./talks/Q-A.jpg": 38,
	"./talks/git.png": 35,
	"./talks/ieee.jpg": 39,
	"./talks/java.jpg": 40,
	"./talks/scaler.jpg": 42,
	"./talksCardBack.svg": 163,
	"./talksCardBackAlt.svg": 164,
	"./techgig.jpeg": 165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 125;